import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326c7259"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card booster-cover-card item-font" }
const _hoisted_2 = { class: "py-4 text-center ps-4 pe-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "card-body p-0 booster-cover-card-middle-border" }
const _hoisted_6 = {
  key: 0,
  class: "bg-white p-3"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "bg-light-gray p-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "Cover amount", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "currency-position currency-text item-body" }, "$")
], -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["min", "max", "onchange"]
const _hoisted_14 = {
  class: "item-label-alt item-placeholder-gray",
  style: {"margin-top":"-0.5rem"}
}
const _hoisted_15 = { class: "float-start" }
const _hoisted_16 = { class: "float-end" }
const _hoisted_17 = {
  key: 1,
  class: "pt-2"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content" }, [
  /*#__PURE__*/_createTextVNode(" If you want to reduce your cover, please call us on "),
  /*#__PURE__*/_createElementVNode("a", { href: "tel: 0800 336 338" }, "0800 336 338")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "card-footer item-placeholder-gray border-0 p-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "Premium (monthly)", -1))
const _hoisted_22 = { class: "item-content" }
const _hoisted_23 = {
  key: 0,
  class: "mt-3 mb-1"
}
const _hoisted_24 = {
  key: 1,
  class: "mt-3 mb-1"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-label" }, "This is your existing cover.", -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "icon-position",
        alt: "Booster",
        src: _ctx.iconRoute
      }, null, 8, _hoisted_3),
      _createElementVNode("span", {
        class: "p-0 ms-2 card-header bg-white border-0 text-center item-label",
        innerHTML: _ctx.title.includes('Booster SmartCover') ? _ctx.title.slice(19) : _ctx.title
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.content.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (reason, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item-content",
                innerHTML: reason
              }, null, 8, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", {
          class: _normalizeClass(["input-row", { 'pb-4': !_ctx.disabled }])
        }, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
            class: _normalizeClass(["cover-amount-input ins-form-control input-icon-padding item-secondary-title item-booster-blue w-100", { 'validation-error': _ctx.validationError }]),
            disabled: _ctx.disabled,
            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)), ["enter"])),
            onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateNumber($event)))
          }, null, 42, _hoisted_11), [
            [_vModelText, _ctx.internalValue]
          ]),
          (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalValue) = $event)),
                  type: "range",
                  class: "form-range booster-range",
                  min: _ctx.minCover,
                  max: _ctx.maxCover,
                  step: "1000",
                  onchange: _ctx.updateValue
                }, null, 8, _hoisted_13), [
                  [_vModelText, _ctx.internalValue]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, "$" + _toDisplayString(_ctx.minCover.toLocaleString()), 1),
                  _createElementVNode("span", _hoisted_16, "$" + _toDisplayString(_ctx.maxCover.toLocaleString()), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, "$" + _toDisplayString(_ctx.monthlyCost.toFixed(2)), 1),
      (!_ctx.disabled && _ctx.showRemove)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn btn-booster-secondary float-start w-100",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showRemoveConfirmation && _ctx.showRemoveConfirmation(...args)))
            }, " Remove from quote ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
        : _createCommentVNode("", true)
    ])
  ]))
}